// extracted by mini-css-extract-plugin
export default {"icon":"PaymentIcons_icon--s2G","link":"PaymentIcons_link--CZ6"};